<template>
    <form-dialog :value="value" @input="$emit('input', $event)" max-width="600">
        <template #activator="bindings">
            <slot v-bind="bindings"></slot>
        </template>
        <template #default="{ open }">
            <update-entity-spend-limit-card
                :value="subscription"
                :loading="$wait.is('updateSubscriptionSpendLimit')"
                #default="{ isValid, formId, loading, form }"
            >
                <back-button @click="open()"></back-button>
                <v-spacer></v-spacer>
                <patch-subscription-button
                    :value="subscription"
                    :patches="[{ op: 'replace', path: 'monthlySpendLimit', value: form.monthlySpendLimit }]"
                    :form="formId"
                    :clear="() => {}"
                    :valid="isValid"
                    :loading="loading"
                    v-wait-while="'updateSubscriptionSpendLimit'"
                    @http2xx="handleSuccessfulSpendLimit"
                ></patch-subscription-button>
            </update-entity-spend-limit-card>
        </template>
    </form-dialog>
</template>

<script>
import UpdateEntitySpendLimitCard from '@/components/Common/UpdateEntitySpendLimitCard.vue';
import PatchSubscriptionButton from '@/components/Domain.Subscriptions/PatchSubscriptionButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    props: {
        value: Boolean,
        subscription: Object,
    },
    components: { UpdateEntitySpendLimitCard, PatchSubscriptionButton },
    methods: {
        handleSuccessfulSpendLimit(response) {
            toastSuccess(`Successfully updated spend limit to ${response.monthlySpendLimit}`);
            this.$emit('input', false);
            this.$emit('http2xx', { ...this.subscription, monthlySpendLimit: response.monthlySpendLimit });
        },
    },
};
</script>